import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnChanges, OnDestroy, Output } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { GridConfig as MsGrid } from '@frontend/sports/common/client-config-data-access';
import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { EventGroup, GridEvent, GridModel } from '@frontend/sports/grid/core/feature/model';
import { GridActions, IGridRootState } from '@frontend/sports/grid/core/feature/store';
import { TRACKING_NO_GAMEDETAILS, TrackingSource } from '@frontend/sports/tracking/feature';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

import { CompactEventComponent } from './content/compact-event.component';
import { EventGroupComponent } from './header/event-group.component';

@Component({
    selector: 'ms-grid-list',
    templateUrl: './grid-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EventGroupComponent, CompactEventComponent],
})
export class GridListComponent implements OnDestroy, OnChanges {
    @Input() model: GridModel;
    @Input() isOutrightMarket: boolean;
    @Input() tracking: string;
    @Input() hideFavourites = false;
    @Input() showAllBetsButton?: boolean;
    @Input() betDetails = '';
    @Input() trackCalenderTitle?: string;
    @Input() hideOptionPanelHeaderForPriceBoost: boolean;

    @HostBinding('class') className = 'grid-list';
    @Output() eventClick = new EventEmitter<GridEvent>();

    displayCompactScoreboardEvent = false;
    showParticipantImage: boolean;
    promotedFixtureIdsMap: StringDictionary<string> = {};

    private destroyed = new Subject<void>();
    private initialized = false;

    constructor(
        private store: Store<IGridRootState>,
        private msGrid: MsGrid,
    ) {
        this.displayCompactScoreboardEvent = this.msGrid.enableCompactEventScoreboard;
        this.showParticipantImage = msGrid.showParticipantLogoOrImage;
    }

    ngOnChanges(): void {
        if (this.initialized) {
            return;
        }

        this.initialized = true;
    }

    ngOnDestroy(): void {
        this.destroyed.next();
        this.destroyed.complete();
    }

    trackingGameDetails(trackingType: string, index: number): TrackingSource {
        const source = this.tracking + '/' + trackingType;

        return { source, position: index, gameDetails: TRACKING_NO_GAMEDETAILS, calendarTitle: this.trackCalenderTitle };
    }

    groupToggled(group: EventGroup): void {
        this.store.dispatch(GridActions.setGroupCollapse({ payload: { id: this.model.id, groupId: group.id } }));
    }

    eventCollapsed(id: string, optionGroupId?: string): void {
        this.store.dispatch(GridActions.collapseEvents({ payload: { id: this.model.id, eventId: id, optionGroupId } }));
    }

    trackEvent = (index: number, event: EventModel) => {
        return `${this.model.id}|${event.id}`;
    };

    eventClicked(event: GridEvent): void {
        this.eventClick.emit(event);
    }

    trackGroup = (index: number, group: EventGroup) => {
        return `${this.model.id}|${group.id}`;
    };
}
